import classNames from "classnames";
import React from "react";
import styles from "./beforeLoginSection.css";

interface Props extends React.HTMLProps<HTMLDivElement> {
  styleType: "signup" | "login";
}

function getStyle(styleType?: "signup" | "login"): string | undefined {
  switch (styleType) {
    case "signup":
      return styles.signup;
    case "login":
      return styles.login;
    default:
      return undefined;
  }
}

export const BeforeLoginSection: React.SFC<Props> = ({
  styleType,
  className,
  children,
  ...restProps
}) => {
  return (
    <section {...restProps} className={classNames(styles.section, getStyle(styleType), className)}>
      {children}
    </section>
  );
};
